angular.module('cvsApp').service('getDigitalSpecialtySSOTokenService',['networkService', 'configManager', 'getDigitalSpecialtySSOTokenModel', 'cvsAppData', function (NS, CM, GDSTM, CAD) {

	function getDigitalSpecialtySSOTokenService (){
		this.getDigitalSpecialtySSOToken = function(SSOServiceDetails, callBackSuccess){
			//get url
            var url = CM.getPbmServiceUrl('GET_Digital_Specialty_SSOToken');
            if (url === "URL_ERROR") {

            } else {
                var request = {
                    url: url,
                    header: { "Content-Type": "application/json", Accept: 'application/json' },
                    data: getRequestBody(SSOServiceDetails),
                    onSuccess: callBackSuccess
                };
                cvsUtility.commonServiceCode(url, "getDigitalSpecialtySSOToken", GDSTM, request, callBackSuccess, NS);
            }
        };

        var getRequestBody = function (serviceDetails) {
            return {
                "digitalSpecialtySSOTokenRequest": {
                    "header": {
                        "serviceContext": {
                            "appName": cvsUtility.queryMap.mobileAppStyle ? 'SPL_APP' : 'SPL_WEB',
                            "channelName": cvsUtility.queryMap.channel,
                            "lineOfBusiness": "Specialty",
                            "tokenType": "SPLLOG",
                            "tokenID": serviceDetails.tokenID,
                        }
                    },
                    "details": {
                        "superUser": {
                            "digitalUserID": serviceDetails.superUser.digitalUserID,
                            "privateID": serviceDetails.superUser.privateID
                        },
                        "patient": {
                            "digitalUserID": serviceDetails.patient.digitalUserID,
                            "privateID": serviceDetails.patient.privateID,
                            "patientIdentifier": serviceDetails.patient.patientIdentifier,
                            "patientSourceSystem": "Specialty HBS",
                            "emailAddress": serviceDetails.patient.emailAddress
                        }
                    }
                }
            }
        }
	}

	return new getDigitalSpecialtySSOTokenService();
}]);
